import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';

import FotoscapeLink from '../../../components/FotoscapeLink/FotoscapeLink.tsx';
import { FOOTER_LINK_LIST, FOOTER_LINK_LIST_BY_LANG } from './constants.ts';

import './Footer.scss';

const Footer: FC = () => {
  const { t, i18n } = useTranslation();
  const [searchParams] = useSearchParams();

  // Check if medium=fsd is in the URL to add padding for adhesion ad
  const hasAdhesionAd = searchParams.get('medium') === 'fsd';

  // Pick the link set matching the active language (e.g. Spanish links for
  // `es`), falling back to the English list for any unsupported language.
  const lang = (i18n.language || 'en').split('-')[0];
  const footerLinkList = FOOTER_LINK_LIST_BY_LANG[lang] ?? FOOTER_LINK_LIST;

  return (
    <nav
      className="moment-footer"
      style={{ paddingBottom: hasAdhesionAd ? '50px' : '0px' }}
    >
      {footerLinkList.map(({ text, link }) => {
        return (
          <div className="moment-footer__link-wrapper" key={text}>
            <FotoscapeLink className="moment-footer__link" to={link}>
              {t(text)}
            </FotoscapeLink>
          </div>
        );
      })}
    </nav>
  );
};

export default Footer;
